
import { useContext, useEffect } from "react";
import { Navigate, Outlet, matchPath, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import AuthContext from "../context/AuthContext";

const PrivateRoute = () => {
    const {
        user,
        routePermissions,
        routePermissionsLoading,
    } = useContext(AuthContext);

    const location = useLocation();
    const navigate = useNavigate();

    const isAuthenticated = Boolean(user);
    const pathname = location.pathname;

    const isAllowed = (routePermissions || []).some((route) =>
        matchPath(
            {
                path: route,
                end: true,
            },
            pathname
        )
    );

    useEffect(() => {
        if (
            isAuthenticated &&
            !routePermissionsLoading &&
            !isAllowed
        ) {
            Swal.fire({
                title: "Access Denied",
                text: "You do not have permission to access this page.",
                icon: "warning",
                confirmButtonText: "OK",
            }).then(() => {
                navigate("/", { replace: true });
            });
        }
    }, [
        isAuthenticated,
        routePermissionsLoading,
        isAllowed,
        pathname,
        navigate,
    ]);

    if (!isAuthenticated) {
        return (
            <Navigate
                to="/user-login"
                replace
                state={{ from: location }}
            />
        );
    }

    if (routePermissionsLoading) {
        return null;
    }

    if (!isAllowed) {
        return null;
    }

    return <Outlet />;
};

export default PrivateRoute;
